import {MapControl, MapControlProps, withLeaflet} from 'react-leaflet';
import * as L from 'leaflet';
import * as React from "react";
import {LeafletMouseEvent} from "leaflet";

interface DragSelectProps extends MapControlProps {
    onSelection: Function,
}

class DragSelect extends MapControl<DragSelectProps, L.Control.EasyButton> {

    private _dragstart: L.Point;
    private _dragrect: L.Polygon;

    private onMouseDownFn = (e: LeafletMouseEvent) => this.onMouseDown(e);
    private onMouseMoveFn = (e: LeafletMouseEvent) => this.onMouseMove(e);
    private onMouseUpFn = (e: LeafletMouseEvent) => this.onMouseUp(e);

    constructor(props: DragSelectProps) {
        super(props);
    }

    enable() {
        this.props.leaflet.map.dragging.disable();
        this.props.leaflet.map.on('mousedown', this.onMouseDownFn);
        this.props.leaflet.map.on('mousemove', this.onMouseMoveFn);
        this.props.leaflet.map.on('mouseup', this.onMouseUpFn);
        this.props.leaflet.map.getContainer().classList.add("dragselect");
    }

    disable() {
        this.props.leaflet.map.dragging.enable();
        this.props.leaflet.map.off('mousedown', this.onMouseDownFn);
        this.props.leaflet.map.off('mousemove', this.onMouseMoveFn);
        this.props.leaflet.map.off('mouseup', this.onMouseUpFn);
        this.props.leaflet.map.getContainer().classList.remove("dragselect");
    }


    createLeafletElement(props: DragSelectProps): L.Control.EasyButton {
        return new L.Control.EasyButton({
            id: 'DragSelectBtn',
            states: [
                {
                    stateName: 'disabled',
                    icon: 'dragselect-tool',
                    title: 'Bytt til velge-modus',
                    onClick: (btn: L.Control.EasyButton) => {
                        this.enable();
                        btn.state('enabled');
                    }
                },
                {
                    stateName: 'enabled',
                    icon: 'dragselect-tool active',
                    title: 'Bytt til vanlig modus',
                    onClick: (btn: L.Control.EasyButton) => {
                        this.disable();
                        btn.state('disabled');
                    }
                }
            ]
        });
    }

    onMouseDown(e: L.LeafletMouseEvent) {
        // In case mouseup happens outside map
        if (!this._dragstart) {
            this._dragstart = e.containerPoint;
            this._dragrect = L.polygon([e.latlng, e.latlng, e.latlng, e.latlng], {color: "#ff7800", weight: 1});
            this._dragrect.addTo(this.props.leaflet.map);
        }
    }

    containerPointToLatLng(point: L.Point) {
        const mapz = this.props.leaflet.map as any;
        return mapz.containerPointToLatLng(point)
    }

    onMouseMove(e: L.LeafletMouseEvent) {
        if (this._dragrect) {
            this.props.leaflet.map.removeLayer(this._dragrect);
            this._dragrect = this.createNewRectangle(e);
            this._dragrect.addTo(this.props.leaflet.map);
        }
    }

    // Calculates dragstart and mousepoint from position on screen to latlngs on map
    private createNewRectangle(e: L.LeafletMouseEvent) : L.Polygon {
        const mousePoint = e.containerPoint as any;
        const latlngs = [
            this.containerPointToLatLng(this._dragstart),
            this.containerPointToLatLng(new L.Point(this._dragstart.x, mousePoint.y)),
            this.containerPointToLatLng(mousePoint),
            this.containerPointToLatLng(new L.Point(mousePoint.x, this._dragstart.y))
        ];
        return L.polygon(latlngs, {color: "#ff7800", weight: 1});
    }

    onMouseUp(e: L.LeafletMouseEvent) {
        if (this._dragstart) {

            if (!this.isClickOnDragSelectIcon(this.leafletElement.getContainer(), e.originalEvent.target as HTMLElement)) {
                const rectangle = this.createNewRectangle(e);
                this.props.onSelection(rectangle.getBounds());
            }

            this.props.leaflet.map.removeLayer(this._dragrect);
            this._dragstart = undefined;
            this._dragrect = undefined;
        }
    }

    private isClickOnDragSelectIcon(leafletElement: HTMLElement, target: HTMLElement) {
        let matchesTarget = (!!target && target == leafletElement);
        let matchesParent = (!!target.parentElement && target.parentElement == leafletElement);
        let matchesGrandParent = (!!target.parentElement && !!target.parentElement.parentElement && target.parentElement.parentElement == leafletElement);
        return matchesTarget || matchesParent || matchesGrandParent;
    }

}

export default withLeaflet(DragSelect);
